import mapActions from './mapActions';

export default mapActions('pipe_dimensions');
